<template>
  <h1 class="asc-pageTitle">{{ title }}<slot></slot></h1>
</template>

<script>
export default {
  name: 'AscPageTitle',

  props: {
    title: {
      type: String,
      default: '',
      required: true,
    },
  },
}
</script>

<style lang="scss">
h1.asc-pageTitle {
  font-size: 14px !important;
  line-height: 18px;
  font-weight: 500;
  text-transform: uppercase;

  &.isSticky {
    padding-left: 16px;
  }
}
</style>
